import store, { AppDispatch } from '../store/store';

const useAppDispatch: () => AppDispatch = () => store.dispatch;
export default useAppDispatch;
